import { Component } from '@angular/core';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Platform } from '@ionic/angular';
import { NavController } from '@ionic/angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  activePageTitle = 'Connections';
  public activeIndex: number;
  Pages = [
    {
      title: 'Connections',
      url: '/connections',
      icon: 'git-branch'
    },
    {
      title: 'Hardware',
      url: '/hardware',
      icon: 'construct'
    },
    {
      title: 'Active Accounts',
      url: '/active-accounts',
      icon: 'car'
    },
    // {
    //   title: 'Login',
    //   url: '/login',
    //   icon: 'person'
    // },
    // {
    //   title: 'Register',
    //   url: '/register',
    //   icon: 'person'
    // }
  
  ];
  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private navController: NavController,

  ) {
    this.initializeApp();
  }
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
  

    });
  }
  goBack() {
    this.navController.back();
  }
}